import { render, staticRenderFns } from "./ConfigDashBoard.vue?vue&type=template&id=66a95f36&scoped=true&"
import script from "./ConfigDashBoard.vue?vue&type=script&lang=js&"
export * from "./ConfigDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDashBoard.vue?vue&type=style&index=0&id=66a95f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a95f36",
  null
  
)

export default component.exports